import { styled } from "@mui/system";
import { IconButton, Box, Modal } from "@mui/material";

export const CustomModal = styled(Modal)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const ModalContent = styled(Box)(({ theme }) => ({
  backgroundColor: "white",
  borderRadius: "20px",
  padding: theme.spacing(8),
  maxWidth: "600px",
  width: "100%",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "32px",

  "&:focus-visible": {
    outline: "none",
  },
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  color: theme.palette.text.primary,
  top: theme.spacing(2),
  right: theme.spacing(2),
  fontSize: "24px",
}));

export const ButtonContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  gap: "16px",
  width: "100%",
}));
